import { render, staticRenderFns } from "./atencionEnfermeria.vue?vue&type=template&id=54672899&scoped=true&"
import script from "./atencionEnfermeria.vue?vue&type=script&lang=js&"
export * from "./atencionEnfermeria.vue?vue&type=script&lang=js&"
import style0 from "./atencionEnfermeria.vue?vue&type=style&index=0&id=54672899&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54672899",
  null
  
)

export default component.exports